export const ACTIVITY_STATUS_COLOR = {
    '1': {
        text: '#006473',
        borderColor: '#006473',
        background: '#EEFDFF'
    },
    '2': {
        text: '#FF6D00',
        borderColor: '#FF6D00',
        background: '#FFF4EB'
    },
    '3': {
        text: '#2962FF',
        borderColor: '#2962FF',
        background: '#EEF3FF'
    },
    '4': {
        text: '#FF6D00',
        borderColor: '#FF6D00',
        background: '#FFF4EB'
    },
    '5': {
        text: '#00944A',
        borderColor: '#00944A',
        background: '#EBF7F1'
    },
    '6': {
        text: '#D50000',
        borderColor: '#D50000',
        background: '#FFF4F4'
    },
    '7': {
        text: '#D50000',
        borderColor: '#D50000',
        background: '#FFF4F4'
    },
    '8': {
        text: '#2962FF',
        borderColor: '#2962FF',
        background: '#EEF3FF'
    },
    '9': {
        text: '#D50000',
        borderColor: '#D50000',
        background: '#FFF4F4'
    }
};

export const ROLE_CONFIG: Record<
    string,
    {
        userType: 'block' | 'district' | 'state' | 'national';
        verticle: string;
        name: string;
        active: boolean;
        ogName: string;
    }
> = {
    'state-manager-ib': {
        userType: 'state',
        verticle: 'Institutional Building',
        name: 'State Manager IB',
        active: true,
        ogName: 'state-manager-ib'
    },
    'state-manager-fi': {
        userType: 'state',
        verticle: 'Financial Inclusion',
        name: 'State Manager FI',
        active: true,
        ogName: 'state-manager-fi'
    },
    'state-manager-farm': {
        userType: 'state',
        verticle: 'Livelihood Farm',
        name: 'State Manager Farm',
        active: true,
        ogName: 'state-manager-farm'
    },
    'state-manager-nonfarm': {
        userType: 'state',
        verticle: 'Livelihood Non-Farm',
        name: 'State Manager Non-Farm',
        active: true,
        ogName: 'state-manager-nonfarm'
    },
    'state-manager-sisd': {
        userType: 'state',
        verticle: 'SISD',
        name: 'State Manager SISD',
        active: true,
        ogName: 'state-manager-sisd'
    },
    'state-administrator': {
        userType: 'state',
        verticle: '',
        name: 'State Admin',
        active: true,
        ogName: 'state-administrator'
    },
    // "state-release-reviewer": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-release-manager": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-finance-manager": {
    //     userType: 'state',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    // "state-approving-authority": {
    //     userType: 'state',
    //     verticle: 'farm',
    //     name: 'State Manager IB',
    //     active: false
    // },

    'block-manager-ib': {
        userType: 'block',
        verticle: 'Institutional Building',
        name: 'Block Manager IB',
        active: true,
        ogName: 'block-manager-ib'
    },
    'block-manager-fi': {
        userType: 'block',
        verticle: 'Financial Inclusion',
        name: 'Block Manager FI',
        active: true,
        ogName: 'block-manager-fi'
    },
    'block-manager-farm': {
        userType: 'block',
        verticle: 'Livelihood Farm',
        name: 'Block Manager Farm',
        active: true,
        ogName: 'block-manager-farm'
    },
    'block-manager-nonfarm': {
        userType: 'block',
        verticle: 'Livelihood Non-Farm',
        name: 'Block Manager Non-Farm',
        active: true,
        ogName: 'block-manager-nonfarm'
    },
    'block-manager-sisd': {
        userType: 'block',
        verticle: 'SISD',
        name: 'Block Manager SISD',
        active: true,
        ogName: 'block-manager-sisd'
    },
    // "block-approving-authority": {
    //     userType: 'block',
    //     verticle: '',
    //     name: 'Block Approving Authority',
    //     active: false
    // },
    // "cbo-bookkeeper": {
    //     userType: 'block',
    //     verticle: '',
    //     name: 'State Manager IB',
    //     active: false
    // },
    'block-administrator': {
        userType: 'block',
        verticle: '',
        name: 'Block Admin',
        active: true,
        ogName: 'block-administrator'
    },

    'national-administrator': {
        userType: 'national',
        verticle: '',
        name: 'National Admin',
        active: true,
        ogName: 'national-administrator'
    },
    'national-manager-ib': {
        userType: 'national',
        verticle: 'Institutional Building',
        name: 'National Manager IB',
        active: true,
        ogName: 'national-manager-ib'
    },
    'national-manager-fi': {
        userType: 'national',
        verticle: 'Financial Inclusion',
        name: 'National Manager FI',
        active: true,
        ogName: 'national-manager-fi'
    },
    'national-manager-nonfarm': {
        userType: 'national',
        verticle: 'Livelihood Non-Farm',
        name: 'National Manager Non-Farm',
        active: true,
        ogName: 'national-manager-nonfarm'
    },
    'national-manager-farm': {
        userType: 'national',
        verticle: 'Livelihood Farm',
        name: 'National Manager Farm',
        active: true,
        ogName: 'national-manager-farm'
    },
    'national-manager-sisd': {
        userType: 'national',
        verticle: 'SISD',
        name: 'National Manager SISD',
        active: true,
        ogName: 'national-manager-sisd'
    },

    'district-manager-ib': {
        userType: 'district',
        verticle: 'Institutional Building',
        name: 'District Manager IB',
        active: true,
        ogName: 'district-manager-ib'
    },
    'district-manager-fi': {
        userType: 'district',
        verticle: 'Financial Inclusion',
        name: 'District Manager FI',
        active: true,
        ogName: 'district-manager-fi'
    },
    'district-manager-farm': {
        userType: 'district',
        verticle: 'Livelihood Farm',
        name: 'District Manager Farm',
        active: true,
        ogName: 'district-manager-farm'
    },
    'district-manager-nonfarm': {
        userType: 'district',
        verticle: 'Livelihood Non-Farm',
        name: 'District Manager Non-Farm',
        active: true,
        ogName: 'district-manager-nonfarm'
    },
    'district-manager-sisd': {
        userType: 'district',
        verticle: 'SISD',
        name: 'District Manager SISD',
        active: true,
        ogName: 'district-manager-sisd'
    },
    'district-administrator': {
        userType: 'district',
        verticle: '',
        name: 'District Admin',
        active: true,
        ogName: 'district-administrator'
    },
    // "district-release-reviewer": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-release-manager": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-finance-manager": {
    //     userType: 'district',
    //     verticle: '',
    //     name: 'District Manager IB',
    //     active: false
    // },
    // "district-approving-authority": {
    //     userType: 'district',
    //     verticle: 'farm',
    //     name: 'District Manager IB',
    //     active: false
    // },
    'district-finance-manager': {
        userType: 'district',
        verticle: 'Livelihood Farm',
        name: 'District Finance Manager Farm',
        active: false,
        ogName: 'district-finance-manager'
    },
    'state-finance-manager': {
        userType: 'district',
        verticle: 'Livelihood Farm',
        name: 'State Finance Manager Farm',
        active: false,
        ogName: 'state-finance-manager'
    }
};

export const LANGUAGE_CONFIG = [
    {
        langName: 'English',
        langCode: 'en',
        translation: 'English',
        isActive: true
    },
    {
        langName: 'Hindi',
        langCode: 'hi',
        translation: 'हिंदी (Hindi)',
        isActive: true
    },
    {
        langName: 'Tamil',
        langCode: 'ta',
        translation: 'தமிழ் (Tamil)',
        isActive: true
    },
    {
        langName: 'Urdu',
        langCode: 'ur',
        translation: 'اردو (Urdu)',
        isActive: true
    },
    {
        langName: 'Kannada',
        langCode: 'kn',
        translation: 'ಕನ್ನಡ (Kannada)',
        isActive: true
    },
    {
        langName: 'Marathi',
        langCode: 'mr',
        translation: 'मराठी (Marathi)',
        isActive: true
    },
    {
        langName: 'Punjabi',
        langCode: 'pa',
        translation: 'ਪੰਜਾਬੀ (Punjabi)',
        isActive: true
    },
    {
        langName: 'Bengali',
        langCode: 'bn',
        translation: 'বাংলা (Bengali)',
        isActive: true
    },
    {
        langName: 'Telugu',
        langCode: 'te',
        translation: 'తెలుగు (Telugu)',
        isActive: true
    },
    {
        langName: 'Sindhi',
        langCode: 'sd',
        translation: 'سنڌي (Sindhi)',
        isActive: true
    },
    {
        langName: 'Gujarati',
        langCode: 'gu',
        translation: 'ગુજરાતી (Gujarati)',
        isActive: true
    },
    {
        langName: 'Sanskrit',
        langCode: 'sa',
        translation: 'संस्कृतम् (Sanskrit)',
        isActive: true
    },
    {
        langName: 'Odia',
        langCode: 'or',
        translation: 'ଓଡିଆ (Odia)',
        isActive: true
    },
    {
        langName: 'Assamese',
        langCode: 'as',
        translation: 'অসমীয়া (Assamese)',
        isActive: true
    },
    {
        langName: 'Bhojpuri',
        langCode: 'bho',
        translation: 'भोजपुरी (Bhojpuri)',
        isActive: true
    },
    {
        langName: 'Awadhi',
        langCode: 'awa',
        translation: 'अवधी (Awadhi)',
        isActive: true
    },
    {
        langName: 'Malayalam',
        langCode: 'ml',
        translation: 'മലയാളം (Malayalam)',
        isActive: true
    },
    {
        langName: 'Nepali',
        langCode: 'ne',
        translation: 'नेपाली (Nepali)',
        isActive: true
    }
];

export const EXCLUDED_STATES = [6, 7, 91, 92];
